import { find, get, includes, groupBy, mapValues, filter, pickBy, values } from 'lodash';
import { DateTime } from 'luxon';
import { getSeason } from '../../clubs/selectors';

export const isLoading = (state, teamId, seasonId) =>
  includes(get(state, 'teams.fixtures.currentlyLoading'), [teamId, seasonId].join('-'));

export const hasLoaded = (state, teamId, seasonId) =>
  includes(get(state, 'teams.fixtures.hasLoaded'), [teamId, seasonId].join('-'));

export const getLoadingError = (state, teamId) =>
  find(get(state, 'teams.fixtures.loadingError'), { teamId });

export const getCompetitions = (state, teamId, seasonId) =>
  values(get(state, `teams.fixtures.competitions[${teamId}][${seasonId}]`, {}));

export const getFixturesGroupByDate = (state, teamId, seasonId) => {
  const fixtures = values(get(state, `teams.fixtures.fixtures[${teamId}]`, {}));
  const season = getSeason(state, seasonId);

  if (!fixtures.length || !season) {
    return {};
  }

  const { start: seasonStart, end: seasonEnd } = season;
  const seasonFixtures = filter(fixtures, (fixture) => {
    const fixtureDate = DateTime.fromISO(fixture.dateTime);
    return (
      fixtureDate >= DateTime.fromFormat(seasonStart, 'yyyy-MM-dd') &&
      fixtureDate <= DateTime.fromFormat(seasonEnd, 'yyyy-MM-dd')
    );
  });

  return groupBy(seasonFixtures, (fixture) =>
    DateTime.fromISO(fixture.dateTime).toFormat('yyyy-MM'),
  );
};

export const getFixtures = (state, teamId, seasonId, competitionId) => {
  const fixturesByDate = getFixturesGroupByDate(state, teamId, seasonId);

  if (!competitionId) {
    return fixturesByDate;
  }

  const filteredFixtures = mapValues(fixturesByDate, (fixtures) =>
    filter(fixtures, ['competitionId', competitionId]),
  );

  return pickBy(filteredFixtures, (fixtures) => fixtures.length);
};
